<template>
  <div>
    <loader :loading="loading" />
    <div class="row">
      <div class="col-4">
        <div class="card" v-if="importedPayment">
          <div class="card-head justify-between">
            <h2 class="h5" :class="{ 'text-success': importedPayment.status === 'assigned' }">{{ $t(importedPayment.status) }}</h2>
          </div>
          <div class="card-body overflow-auto">
            <div class="row row-cols-2">
              <div class="text-center">
                <h4 v-text="$t('importedpayment.amount')" />
                <h2 class="text-secondary">{{ importedPayment.transaction_amount | currency }}</h2>
              </div>
              <div class="text-center">
                <h4 v-text="$t('importedpayment.linked_amount')" />
                <h2 class="text-primary">{{ importedPayment.linked_amount | currency }}</h2>
              </div>
            </div>
            <hr>
            <field type="column" label="importedpayment.account_iban" :value="importedPayment.account_iban" />
            <field type="column" label="importedpayment.account_bic" :value="importedPayment.account_bic" />
            <field type="column" label="importedpayment.acount_name" :value="importedPayment.account_name" />
            <field type="column" label="importedpayment.reference" :value="importedPayment.transaction_reference" />
            <field type="column" label="importedpayment.transaction_date" :value="importedPayment.transaction_date | date" />
            <field type="column" label="importedpayment.address" :value="importedPayment.address" />
            <field type="column" label="importedpayment.informational_message1" :value="importedPayment.informational_message1" />
            <field type="column" label="importedpayment.informational_message2" :value="importedPayment.informational_message2" />
            <field type="column" label="importedpayment.informational_message3" :value="importedPayment.informational_message3" />
          </div>
        </div>
      </div>
      <div class='col-8'>
        <div class="card" v-if="table">
          <div class="card-head">
            <h2 class="h5">{{ $t('importedPayment.assigned.payments.title') }}</h2>
          </div>
          <div class="card-body">
            <data-table v-bind="{ model, endpoint, data: table }" prefix='payments' @action="doAction" :ref="`${model}List`" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { AxiosResponse } from 'axios';
import { EmitterAction, Table } from '@/models';
import Field from '@/components/global/Field.vue';
import api from '@/api';
import { ListComponent } from '@/mixins/ListComponent';
import { ImportedPayment } from '@/models/ImportedPayment';

@Component({
  components: { Field },
})
export default class ImportedPaymentAssignedView extends mixins(ListComponent) {
  protected model: string = 'importedPaymentAssigned';
  protected table: null | Table = null;
  protected importedPayment: null | ImportedPayment = null;

  protected mounted() {
    this.setDataTable();
    this.loadData();
  }

  protected async loadData() {
    if (!this.endpoint) {
      return;
    }

    this.loading = true;
    await api.get(this.endpoint)
      .then(res => {
        if (res.data.payments) {
          this.table = res.data.payments.table;
        }

        if(res.data.importedPayment) {
          this.importedPayment = res.data.importedPayment;
        }

        this.loading = false;
        this.afterLoad(res);
      }).catch(() => {
        this.loading = 'error';
      });
  }

  protected afterSubmit(success: boolean, response: AxiosResponse) {
    this.afterLoad(response);
  }

  protected async doAction(action: EmitterAction) {
    if (action.emit === 'revert_payment') {
      await this.delete(`/imported_payment/payment/${action.id}/delete`);
    }
  }

  protected async delete(endpoint: string ) {
    await this.showConfirmation(this.$t('imported_payment.payment.delete.confirmation') as string)
      .then(() => { api.delete(endpoint) });
  }

  private get endpoint() {
    return `imported_payment/assigned/${this.$route.params.id}/view`;
  }
}
</script>
